import React from "react";
import { Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaThLarge } from "react-icons/fa";
import { Seller } from "../Components";

const BlueHeights = () => {
  return (
    <>
      <div className="title-bar-wrapper">
        <Container>
          <Row>
            <div className="title">
              <h1>Blue Heights</h1>
            </div>
            <ul className="bread-crumb pull-right">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>-</li>
              <li>Blue Heights</li>
            </ul>
          </Row>
        </Container>
      </div>
      <div className="inner-page-bg">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="why-projects">
                <div className="why-projects-title">
                  <h2>Why Zeeshan Blue Heights?</h2>
                  <div className="why-projects-dec">
                    Project is only 5 minutes from Airport.
                  </div>
                  <div className="why-projects-dec">
                    Project is 2-3 minutes away from vip road Kaikhali Bus Stop.
                  </div>
                  <div className="why-projects-dec">
                    BANK OFFER- HDFC, IDBI, LIC HOUSING FINANCE, Standard
                    Chartered Bank,ICICI Bank and IIFL Finance Limited.
                  </div>
                </div>
              </div>
              <div className="overview-details">
                <h2>Zeeshan Blue Heights Overview</h2>
                <div className="overview-main">
                  <div className="row">
                    <div className="col-lg-4">
                      <div className="overview-single d-flex align-items-center">
                        <div className="overview-icon">
                          <FaThLarge />
                        </div>
                        <div>
                          <span>Project Area</span>
                          <p className="mb-0">0.09 Acres</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="overview-single d-flex align-items-center">
                        <div className="overview-icon">
                          <FaThLarge />
                        </div>
                        <div>
                          <span>Sizes</span>
                          <p className="mb-0">407.00 sq.ft. - 1606.00 sq.ft.</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="overview-single d-flex align-items-center">
                        <div className="overview-icon">
                          <FaThLarge />
                        </div>
                        <div>
                          <span>Project Size</span>
                          <p className="mb-0">1 Building - 15 units</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="overview-single d-flex align-items-center">
                        <div className="overview-icon">
                          <FaThLarge />
                        </div>
                        <div>
                          <span>Avg. Price</span>
                          <p className="mb-0">4.00 K/sq.ft</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="overview-single d-flex align-items-center">
                        <div className="overview-icon">
                          <FaThLarge />
                        </div>
                        <div>
                          <span>Possession Startse</span>
                          <p className="mb-0">May, 2023</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="overview-single d-flex align-items-center">
                        <div className="overview-icon">
                          <FaThLarge />
                        </div>
                        <div>
                          <span>Configurations</span>
                          <p className="mb-0">1, 2, 3, 4 BHK Apartments</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="group-all-btn">
                    <button>View as 99</button>
                    <button>View as Magic Bricks</button>
                    <button>View as Xyz</button>
                  </div>
                </div>
              </div>
              <div className="overview-details">
                <h2>About Zeeshan Blue Heights</h2>
                <div className="overview-main about-for-project">
                  <p>
                    Blue Heights in Kaikhali, Kolkata is offering trendy homes.
                    The Apartments are under construction and the apartments are
                    available through the builder. Several amenities are present
                    for the community, landscaped garden, Lift, Bike parking,
                    car parking, CCTV Surveillance, Security, Intercom,
                    children's play area and round the clock security amongst
                    others. Kaikhali is one of the top most localities in
                    kolkata and is located in suburb locality of Airport . The
                    area has a great number of apartments for sale with
                    something to suit everyone tastes and budgets ensuring
                    comfort to fulfil everyone needs and requirements.
                  </p>
                  <b>More About This Property</b>
                  <span>
                    Residential project, Zeeshan Blue Heights in Kolkata is
                    offering units for sale in Kaikhali. Check out some
                    Apartment that suit your lifestyle and liking. Possession
                    date of Zeeshan Blue Heights is May, 2023. The property
                    offers 1 BHK, 2 BHK, 3 BHK, 4 BHK units. As per the area
                    plan, units are in the size range of 407.0 - 1606.0 sq.ft..
                    The project by Zeeshan Construction is set in 0.09 Acres .
                    It has 15 units. There is 1 building in this project.
                    Contact for further details. Zeeshan Blue Heights is located
                    in Kaikhali.
                  </span>
                  <span>
                    In terms of facilities, Zeeshan Blue Heights is loaded with
                    multiple offerings such as Power Backup. There is 24x7
                    Security.
                  </span>
                  <span>
                    Bank financing is approved by the following financial
                    institutions such as HDFC, LIC Housing Finance.
                  </span>
                  <span>
                    Zeeshan Blue Heights follows all rules as prescribed by the
                    state RERA. All details are furnished on the RERA portal as
                    well.ID is ..
                  </span>
                  <span>
                    Zeeshan Construction is a very well-known developer-firm in
                    this real estate market. Residents and their lifestyle are
                    at the centre of their developments.
                  </span>
                  <span>
                    Prominent suburbs of Kolkata are close by to Kaikhali and
                    with several schools, hospitals, banks and offices situated
                    in the proximity, the project is a preferred choice for home
                    seekers.
                  </span>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <Seller />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BlueHeights;
